"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TabsType = exports.ProductListTabs = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _clsx2 = _interopRequireDefault(require("clsx"));
var _react = _interopRequireWildcard(require("react"));
var _getPrefixCls = require("../../utils/getPrefixCls");
var _Tabs = require("../Tabs");
var _ProductList = require("./ProductList");
var _Button = require("../Button");
function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }
  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }
  var cache = _getRequireWildcardCache(nodeInterop);
  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }
  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }
  newObj.default = obj;
  if (cache) {
    cache.set(obj, newObj);
  }
  return newObj;
}
var TabsType;
exports.TabsType = TabsType;
(function (TabsType) {
  TabsType["noUnderscore"] = "noUnderscore";
  TabsType["underscore"] = "underscore";
  TabsType["userTypeUnderscore"] = "userTypeUnderscore";
})(TabsType || (exports.TabsType = TabsType = {}));
var ProductListTabs = function ProductListTabs(props) {
  var _userTypes$;
  var tabs = props.tabs,
    onLoadMore = props.onLoadMore,
    selectOrderText = props.selectOrderText,
    defaultSelected = props.defaultSelected,
    itemText = props.itemText,
    itemsText = props.itemsText,
    userTypes = props.userTypes,
    showOrderId = props.showOrderId,
    showUserTypeTab = props.showUserTypeTab,
    onButtonClick = props.onButtonClick,
    onMainTabClick = props.onMainTabClick,
    trackingData = props.trackingData,
    componentTrackingData = props.componentTrackingData,
    showLoading = props.showLoading,
    tabsType = props.tabsType,
    showScrollIcon = props.showScrollIcon,
    showStillNotFound = props.showStillNotFound,
    onClickStillNotFound = props.onClickStillNotFound,
    stillNotFoundButtonText = props.stillNotFoundButtonText,
    previewMockData = props.previewMockData,
    formatOrderListItem = props.formatOrderListItem,
    statusText = props.statusText,
    isUIOptimisation = props.isUIOptimisation,
    _props$productOrOrder = props.productOrOrderEmptyText,
    productOrOrderEmptyText = _props$productOrOrder === void 0 ? '' : _props$productOrOrder,
    _props$noMoreText = props.noMoreText,
    noMoreText = _props$noMoreText === void 0 ? '' : _props$noMoreText;
  var _useState = (0, _react.useState)(userTypes === null || userTypes === void 0 ? void 0 : (_userTypes$ = userTypes[0]) === null || _userTypes$ === void 0 ? void 0 : _userTypes$.type),
    _useState2 = (0, _slicedToArray2.default)(_useState, 2),
    userTypeState = _useState2[0],
    setUserTypeState = _useState2[1];
  var prefixCls = (0, _getPrefixCls.getPrefixCls)('product-list'); // UserTab切换触发

  var handleMainTabClick = function handleMainTabClick(index) {
    var _userTypes$index;
    setUserTypeState(userTypes === null || userTypes === void 0 ? void 0 : (_userTypes$index = userTypes[index]) === null || _userTypes$index === void 0 ? void 0 : _userTypes$index.type);
  };
  (0, _react.useEffect)(function () {
    onMainTabClick === null || onMainTabClick === void 0 ? void 0 : onMainTabClick(userTypeState);
  }, [userTypeState]);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "".concat(prefixCls, "-tabs")
  }, showUserTypeTab ? /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
    className: "".concat(prefixCls, "-user-tabs")
  }, userTypes === null || userTypes === void 0 ? void 0 : userTypes.map(function (userType, index) {
    return /*#__PURE__*/_react.default.createElement("div", {
      key: userType.type,
      className: (0, _clsx2.default)("".concat(prefixCls, "-user-item"), (0, _defineProperty2.default)({}, "".concat(prefixCls, "-user-item--selected"), userTypeState === userType.type)),
      onClick: function onClick() {
        return handleMainTabClick(index);
      }
    }, userType.name);
  }))) : null, /*#__PURE__*/_react.default.createElement(_Tabs.Tabs, {
    titles: tabs,
    className: "".concat(prefixCls, "-tabs-content-class"),
    defaultSelected: defaultSelected,
    key: userTypeState,
    type: tabsType,
    showScrollIcon: showScrollIcon,
    componentTrackingData: componentTrackingData
  }, tabs.map(function (title, index) {
    return /*#__PURE__*/_react.default.createElement(_ProductList.ProductList // eslint-disable-next-line react/no-array-index-key
    , {
      key: index,
      type: title.type,
      name: title.name,
      disabled: title.disabled,
      userType: userTypeState,
      onLoadMore: onLoadMore,
      selectOrderText: selectOrderText,
      itemText: itemText,
      itemsText: itemsText,
      showOrderId: showOrderId,
      onButtonClick: onButtonClick,
      trackingData: trackingData,
      componentTrackingData: componentTrackingData,
      showLoading: showLoading,
      previewMockData: previewMockData,
      formatOrderListItem: formatOrderListItem,
      statusText: statusText,
      isUIOptimisation: isUIOptimisation,
      productOrOrderEmptyText: productOrOrderEmptyText,
      noMoreText: noMoreText
    });
  })), showStillNotFound && /*#__PURE__*/_react.default.createElement("div", {
    className: "".concat(prefixCls, "-footer")
  }, /*#__PURE__*/_react.default.createElement(_Button.Button, {
    className: "".concat(prefixCls, "-not-found"),
    text: stillNotFoundButtonText || 'Still Not Found',
    type: "secondary-outlined",
    onClick: onClickStillNotFound
  })));
};
exports.ProductListTabs = ProductListTabs;